require('./_wks-define')('observable');



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es7.symbol.observable.js
 ** module id = 514
 ** module chunks = 2
 **/